<template>
  <div class="cp-share mobile" @click="handleClose">
    <div class="text">
      还可以召集<span class="times">{{userInfo.weixin_state ? userInfo.invitablenum : 4}}</span>名兄弟
    </div>
  </div>
</template>

<script>
// 移动端头部
import store from '~/store/index';
import * as types from '~/store/mutation-type';
import { mapState } from "vuex";


export default {
  name: 'share',
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    })
  },
  methods: {
    handleClose() {
      store.commit(types.HIDE_MODAL);
    }
  }
};
</script>

<style lang="stylus" scoped>
  .cp-share
    position absolute
    width 100%
    height 100%
    background-size: 6.42rem 3.65rem;
    background-image url('./images/share.png')
    background-repeat: no-repeat;
    background-position 0.7rem 0.87rem
    .text
      font-size 0.3rem
      line-height 1
      margin-top 5.58rem
      width 100%
      text-align center
      color: #ffcd87;
      letter-spacing 0.05rem
      .times
        color: #fff
        font-size 0.4rem
</style>
